export const environment = {
  production: false,
  mapbox: {
    apiKey:
      'pk.eyJ1IjoiaW5zaWdodC1hY2NvdW50cyIsImEiOiJjajdpeHZudWoxdHkyMzNtbGJqOXliaDg5In0.TqnzZNfIrxndw2lGlE_MkQ',
  },
};
